'use client'

export interface TabItem {
  label: string | JSX.Element
}

export function TabsHeader({selectedTab, items, onChange}: {
  selectedTab?: number,
  items: TabItem[],
  onChange: (selectedTab: number) => void
}) {

  const handleChange = (t: any) => {
    onChange(t)
  }

  return (<div>
    <div className="sm:hidden">
      <label className="sr-only">Select your country</label>
      <select onChange={c => handleChange(parseInt(c.target.value))}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        {items.map((it, i) => <option key={'tab-mob-' + it.label} value={i}>{it.label}</option>)}
      </select>
    </div>

    <ul
      className="hidden text-sm font-medium text-center text-gray-500 rounded-lg shadow sm:flex dark:divide-gray-700 dark:text-gray-400">
      {items.map((it, i) => <li key={'tab-desk-' + it.label} className="w-full">
        <a href="#" onClick={() => handleChange(i)}
           className="inline-block w-full p-4 text-gray-900 bg-gray-100 border-r border-gray-200 dark:border-gray-700 rounded-s-lg focus:ring-4 focus:ring-blue-300 active focus:outline-none dark:bg-gray-700 dark:text-white"
           aria-current="page">
          {it.label}
        </a>
      </li>)}
    </ul>

  </div>)
}